import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ProjectApi from "../../Data/HomePage/PortfolioApi";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Modal, Button } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from "react-bootstrap/Nav";
import ListGroup from 'react-bootstrap/ListGroup';
import "./PortfolioDetail.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import leftarrow from "../../../src/assets/images/left-arrow-white.png";

function PortfolioDetail() {
  const { projectId } = useParams();
  const project = ProjectApi.categories
    .flatMap((category) => category.projects)
    .find((project) => project.id === parseInt(projectId));

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (!project) {
    return <div>Project not found!</div>;
  }

  return (
    <div className="project-details-container container-fluid">
      <Nav
        className="navbar bg-dark border border-body fixed-top bg-body-tertiary"
        data-bs-theme="dark"
        activeKey="/home"
      >
        <div className="container">
          <Navbar.Brand href="/"><img src={leftarrow} alt="left arrow" /></Navbar.Brand>
          <Nav.Item className="m-auto">
            <Nav.Link className="text-white">{project.title}</Nav.Link>
          </Nav.Item>
        </div>
      </Nav>
      <div className="container pt-5 mt-0">
        <div className="row">
          <div className="col">
            <img
              src={project.banner}
              alt={project.title}
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
            />
          </div>
        </div>
        <div className="row py-5">
          <div className="col">
            <p>{project.description && <strong>Description:</strong>} {project.description}</p>
            <p>{project.longDescription && <strong>Detailed Description:</strong>} {project.longDescription}</p>
            <p>{project.client && <strong>Client:</strong>} {project.client}</p>
            <p>{project.role && <strong>Role: {project.role}</strong>}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-5">
            <Swiper
              effect={"cards"}
              grabCursor={true}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              modules={[EffectCards]}
              className="mySwiper"
            >
              {project.screenshots.map((screenshot, index) => (
                <div key={index}>
                  <SwiperSlide>
                    <img src={screenshot} alt={`Screenshot ${index + 1}`} />
                  </SwiperSlide>
                </div>
              ))}
            </Swiper>
          </div>
          <div className="col-md-7">
            <div className="project-info bg-dark p-3 rounded shadow-sm">
              <p><strong>Technology Stack:</strong> {project.techStack.join(", ")}</p>
              <p>{project.appArchitecture && <strong>App Architecture: </strong>} {project.appArchitecture}</p>
              <p><strong>Project URL:</strong> <a href={project.url}>{project.url}</a></p>
              <p><strong>Source Code:</strong> <a href={project.sourceCode}>{project.sourceCode}</a></p>
              <p><strong>Video Demo:</strong> <Button variant="outline-success" size="sm" onClick={handleShow}>View</Button></p>
              <p><strong>API Documentation:</strong> <a href={project.documentationLink} className="btn btn-outline-success btn-sm" target="_blank">View</a></p>
              <p><strong>Development Process:</strong> {project.developmentProcess}</p>
            </div>
            <div className="featureList">
              <h4>Feature List</h4>
              <ListGroup as="ol" numbered variant="flush">
                {project.features.map((feature, index) => (
                  <ListGroup.Item as="li" key={index}>{feature}</ListGroup.Item>
                ))}
              </ListGroup>
            </div>
            <div>
              <h4>Challenges and Solutions</h4>
              {project.challenges.map((challenge) => (
                <div key={challenge.problem}>
                  <p><strong>Problem:</strong> {challenge.problem}</p>
                  <p><strong>Solution:</strong> {challenge.solution}</p>
                </div>
              ))}
            </div>
            <p><strong>Completion Date:</strong> {project.completionDate}</p>
            <p><strong>Case Studies:</strong> <a href={project.caseStudies}>{project.caseStudies}</a></p>
            <p><strong>Future Enhancements:</strong> {project.futureEnhancements}</p>
            <div>
              <h4>Collaborators</h4>
              {project.collaborators.map((collaborator) => (
                <p key={collaborator.name}>{collaborator.name} - {collaborator.role}</p>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{project.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="video-container" style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
            <iframe
               style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
              src={project.videoDemo}
              title={project.title}
              frameborder="0"
              autoplay="1"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
              </iframe>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PortfolioDetail;
